export default {
  formType: 'formTypes',
  reportType: 'lookup/ReportType',
  // dashboard
  dashboard: 'dashboard',
  jobSelectDashboard: 'jobs',
  // annotation editor
  issueType: 'lookup/IssueType',
  // asset filters
  jobFilterAsset: 'jobs',
  orgFilterAsset: 'lookup/Organization',
  // document filters
  documentTagFilterDocument: 'lookup/DocumentTag',
  jobFilterDocument: 'jobs',
  // fillFromPreviousButton
  reportTypeFillFrom: 'lookup/ReportType',
  // issue modal
  employeeModalAssign: 'employees',
  reportAssignmentModalAssign: 'lookup/ReportAssignment',
  issueAssignmentModalAssign: 'lookup/IssueAssignment',
  issueModalAssign: 'issues',
  // issue filters
  creatorFilterIssue: 'lookup/Creator',
  issueSeverityFilterIssue: 'lookup/IssueSeverity',
  issueStatusFilterIssue: 'lookup/IssueStatus',
  jobComponentCodeFilterIssue: 'lookup/JobComponentCode',
  jobFilterIssue: 'jobs',
  reportFilterIssue: 'reports',
  reportTypeFilterIssue: 'lookup/ReportType',
  issueComponentCode: 'lookup/JobComponentCode',
  reportTypeIssueType: 'lookup/ReportTypeIssueType',
  issueAssignmentFilterIssue: 'lookup/IssueAssignment',
  // job filters
  organizationFilterJob: 'lookup/Organization',
  // report filters
  assetFilterReport: 'lookup/Asset',
  currentStateFilterReport: 'lookup/CurrentState',
  reportAssignmentFilterReport: 'lookup/ReportAssignment',
  creatorFilterReport: 'lookup/Creator',
  issueSeverityFilterReport: 'lookup/IssueSeverity',
  jobAndPhaseCodeFilterReport: 'lookup/JobAndPhaseCode',
  jobFilterAdd: 'jobs',
  jobPicker: 'jobs',
  jobPieceFilterReport: 'lookup/JobPiece',
  orgFilterReport: 'lookup/Organization',
  pieceOtherFilterReport: 'lookup/PieceOther',
  reportTagFilterReport: 'lookup/ReportTag',
  reportTypeFilterAdd: 'lookup/ReportType',
  reportTypeFilterReport: 'lookup/ReportType',
  statusFilterReport: 'lookup/Status',
  pieceOtherComponent: 'lookup/PieceOther',
  pieceComponentReport: 'lookup/JobPiece',
  // contract spec detail
  jobSelectContractSpec: 'jobs',
  contractSpecFilterContractSpec: 'contractSpecs',
  // documents detail
  jobSelectDocument: 'jobs',
  jobSelectUploadDocument: 'jobs',
  // editor detail
  reportSelectEditor: 'reports',
  reportWithNDT: 'reports',
  reportWithMaintenance: 'reports',
  // issue detail
  jobComponentCodeSelectIssue: 'lookup/JobComponentCode',
  issuePopoverReportDocument: 'lookup/ReportDocument',
  issueIssueItem: 'lookup/IssueIssueItem',
  // job detail
  orgSelectJob: 'lookup/Organization',
  reportTypeSelectJob: 'lookup/ReportType',
  // issue bulk actions
  reportTypeIssueBulkExport: 'lookup/ReportType',
  jobIssueBulkExport: 'jobs',
  // summaries
  summary: 'summaries',
  // other
  jobBulkActionDocument: 'jobs',
  // employees job filter
  jobFilterEmployees: 'jobs',
  // employee document certification form
  documentCertificationForm: 'library',
  // job general employee dropdown
  jobGeneralEmployee: 'employees',
  // associated assets sections (job, employee)
  associatedAsset: 'lookup/Asset',
  associatedAssetOrganization: 'lookup/Organization',
  associatedAssetType: 'lookup/AssetType',
  // asset detail -> associations
  assetAssociationsDocument: 'lookup/LibraryDocument',
  assetAssociationsEmployee: 'lookup/Employee',
  assetAssociationsJob: 'jobs',
  assetAssociationsFacility: 'lookup/Facility',
  assetAssociationsArea: 'lookup/FacilityGroupArea',
  assetAssociationsGroup: 'lookup/FacilityGroup',
  assetAssociationsOrganization: 'lookup/Organization',
  // summary
  jobSelectSummary: 'jobs',
  // formForm
  formForm: 'lookup/FormForm'
};